import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24489773"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-nft" }
const _hoisted_2 = { class: "nft-image-shadow" }
const _hoisted_3 = { class: "nft-image box-border" }
const _hoisted_4 = { class: "box-img" }
const _hoisted_5 = {
  key: 0,
  class: "nft-loading"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "granule-bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "granule-bg-linear" })
], -1))
const _hoisted_8 = { class: "nft-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.imageLoadFinish)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_loading)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _ctx.nft.image,
            alt: "",
            onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imageLoad && _ctx.imageLoad(...args))),
            style: _normalizeStyle({ opacity: _ctx.imageLoadFinish ? 1 : 0 })
          }, null, 44, _hoisted_6)
        ])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.nft.name), 1)
  ]))
}